<template>
  <div class="block-infoboks" style="max-width: 640px">
    <img :src="$api_url + value.Ikon.url" uk-img />
    <div v-html="content"></div>
  </div>
</template>

<script>
import Renderer from "./mixin";

export default {
  computed: {
    content() {
      if (this.$i18n.locale == "no") {
        return this.$md.render(this.Innhold);
      } else {
        return this.$md.render(this.Innhold_eng);
      }
    },
  },
  mixins: [Renderer(["Innhold", "Innhold_eng"])],
};
</script>
<style lang="scss">
.block-infoboks {
  $spacing: 1.5rem;
  margin-top: 3rem;
  margin-bottom: 3rem;
  padding: $spacing;
  font-size: 0.95em;

  background: linear-gradient(128deg, rgb(243 247 246), rgb(232 239 238));
  display: grid;
  align-items: center;
  grid-gap: $spacing;
  grid-template-columns: 50px 1fr;

  p:last-child {
    margin-bottom: 0;
  }
  h3 {
    margin-top: 0px !important;
  }
}
</style>
